export default __webpack_public_path__ + "static/banner-870563105b167b54e83cd7094c64b773.png";